import React from "react";
import { Box } from "@mui/material";
import AppButton from "./AppButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

/**
 * RfiFooter - Fixed footer for approval/rejection actions in ViewRfi
 * @param {boolean} viewOnly - If true, show Approve/Reject; else, show Send for approval
 * @param {function} onReject - Handler for Reject button
 * @param {function} onApprove - Handler for Approve button
 * @param {function} onSendForApproval - Handler for Send for approval button
 * @param {boolean} isLoading - When true, show loading state on Send for approval button
 */
const RfiFooter = ({
  onReject,
  onApprove,
  onSendForApproval,
  isLoading = false,
  submitButtonText = "Send for approval to QC Coordinator",
  showSubmitButton = true,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        gap: 5,
        justifyContent: "flex-end",
      }}
    >
      {!showSubmitButton ? (
        <>
          <AppButton
            buttonType="greyed"
            variant="contained"
            label="Reject"
            startIcon={<CancelOutlinedIcon />}
            onClick={onReject}
          />
          <AppButton
            buttonType="primary"
            variant="contained"
            label="Approve"
            startIcon={<CheckCircleOutlineIcon />}
            onClick={onApprove}
          />
        </>
      ) : (
        <AppButton
          buttonType="primary"
          variant="contained"
          label={submitButtonText}
          onClick={onSendForApproval}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
};

export default RfiFooter;
